import {
  userTrackerHub,
  customerSupportHub,
  startHub,
  userTracker,
  customerSupport,
  loggerHub,
  logger,
  plc,
  plcHub,
  uploadHub,
  upload,
} from "@/utils/signalR";
import { comAxiosWithToken } from "@/utils/communucationApi";
import fetchAx from "@/axios.js";

export default {
  namespaced: true,
  state: {
    key: {
      userConnected: "UserConnected",
      userDisconnect: "UserDisconnected",
      upodateUserCount: "UserCountChanged",
      joinGroup: "JoinGroup",
      leaveGroup: "LeaveGroup",
      totalUser: "CustomerSupportTotalUserCountChanged",
      CreateTicket: "CreateTicket",
      UpdateTicket: "UpdateTicket",
      DeleteTicket: "DeleteTicket",
      SendMessage: "SendMessage",
      SendTypingNotification: "SendTypingNotification",
      TicketCreated: "TicketCreated",
      TicketUpdated: "TicketUpdated",
      TicketDeleted: "TicketDeleted",
      NewMessage: "NewMessage",
      Typing: "Typing",
      CustomerAgentsGroup: "CustomerAgents",
      joinCompany: "JoinMyCompanyGroup",
    },

    userToken: localStorage.getItem("UserToken") || null,
    miniAuth: localStorage.getItem("miniAuth") || null,
    signalRToken: localStorage.getItem("SignalRToken") || null,
    userIdList: [],
    ticketList: [],
    userList: [],
    myUser: JSON.parse(localStorage.getItem("UserData")) || null,
    messageList: [],
    activeTicket: null,
    isTyping: false,
    companyAgents: [],
    newTicket: 0,
    currentRoute: null,
    searchQuery: "",
    updateTicket: null,
    handlerIds: [],
    responderIDs: [],
    selectedTicket: {},
    count: 0,
    isAgent: false,
    customerDesc: null,
  },
  mutations: {
    setMiniAuth(state, payload) {
      state.miniAuth = payload;
    },
    addCount(state) {
      state.count += 1;
    },
    setUpdateTicket(state, payload) {
      state.updateTicket = payload;
      const index = state.ticketList.findIndex(
        (ticket) => ticket.id === state.updateTicket.id
      );
      if (index !== -1) {
        state.ticketList.splice(index, 1, { ...state.updateTicket });
      }
      if (index == -1) {
        state.ticketList.push(state.updateTicket);
      }
    },
    setSignalRToken(state, payload) {
      state.signalRToken = payload;
    },
    setUserToken(state, payload) {
      state.userToken = payload;
    },
    setUserTracker(state, payload) {
      state.userTracker = payload;
    },
    setCustomerSupport(state, payload) {
      state.customerSupport = payload;
    },
    setTicketList(state, payload) {
      state.ticketList = payload;
    },
    setUserIdList(state) {
      state.ticketList.forEach((ticket) => {
        if (ticket.handlerIds.length > 0) {
          ticket.handlerIds.forEach((handler) => {
            if (state.userIdList.length > 0) {
              !state.userIdList.find((id) => id == handler.toString())
                ? state.userIdList.push(handler.toString())
                : "";
            } else {
              state.userIdList.push(handler.toString());
            }
          });
        }
        if (ticket.responderIDs.length > 0) {
          ticket.responderIDs.forEach((responder) => {
            if (state.userIdList.length > 0) {
              !state.userIdList.find((id) => id == responder.toString())
                ? state.userIdList.push(responder.toString())
                : "";
            } else {
              state.userIdList.push(responder.toString());
            }
          });
        }

        if (!state.userIdList.find((id) => id == ticket.userId.toString())) {
          state.userIdList.push(ticket.userId.toString());
        }
      });
    },
    setUserList(state, payload) {
      state.userList = payload;
    },
    setMyUser(state, payload) {
      state.myUser = payload;
    },
    setMessageList(state, payload) {
      const { id, messages } = payload;
      const message = state.messageList.find((ticket) => ticket.id == id);
      if (message) {
        message.messages = messages;
      } else {
        state.messageList.push({ id: id, messages: messages });
      }
    },
    setActiveTicket(state, payload) {
      state.activeTicket = payload;
      state.selectedTicket = {
        ...state.ticketList.find((ticket) => ticket.id == payload),
      };
    },
    addMessage(state, payload) {
      const isTicketIn = state.messageList.find(
        (element) =>
          payload.ChatId === element.id || payload.chatId === element.id
      );
      if (!isTicketIn) {
        this.commit("b2bSignalRStore/addTicketIdInMessageList", payload);
      }
      state.messageList.forEach((element) => {
        if (element.id == payload.ChatId || payload.chatId === element.id) {
          element.messages.push(payload);
        }
      });
    },
    resetAll(state) {
      state.userToken = null;
      state.userIdList = [];
      state.ticketList = [];
      state.userList = [];
      state.myUser = null;
      state.messageList = [];
      state.activeTicket = null;
      state.signalRToken = null;
      state.isAgent = false;
    },
    addTicket(state, payload) {
      state.ticketList.unshift(payload);
    },
    setIsTyping(state, payload) {
      state.isTyping = payload;
    },
    setCompanyAgents(state, payload) {
      state.companyAgents = payload;
    },
    setNewTicket(state) {
      state.newTicket = state.newTicket + 1;
    },
    updateRoute(state, route) {
      state.currentRoute = route;
    },
    resetNewTicket(state) {
      state.newTicket = 0;
    },
    setSearchQuery(state, payload) {
      state.searchQuery = payload;
    },
    setCloseTicket(state, payload) {
      state.ticketList.forEach((ticket) => {
        if (ticket.id == payload) {
          ticket.status = 4;
        }
      });
    },
    setIsAgent(state, payload) {
      if (payload !== false) {
        const findUser = payload.find((user) => user.d7K_ID == state.myUser.id);
        if (findUser) {
          state.isAgent = findUser.isAgent;
          localStorage.setItem("isAgent", findUser.isAgent);
        } else {
          state.isAgent = false;
          localStorage.setItem("isAgent", false);
        }
      } else {
        state.isAgent = false;
        localStorage.setItem("isAgent", false);
      }
    },
    addOneUserId(state, payload) {
      state.userIdList.push(payload.toString());
    },
    setCustomerDesc(state, payload) {
      state.customerDesc = payload;
    },
  },
  getters: {
    getCustomer: (state) => state.customerDesc,
    getMyUser: (state) => state.myUser,
    getTicketList(state) {
      return state.ticketList
        .filter((ticket) => {
          if (ticket.status !== 4) {
            if (
              ticket.responderIDs.length == 0 &&
              ticket.handlerIds.length == 0
            ) {
              const user = state.userList.find(
                (user) => Number(user.userIdentifier) == ticket.userId
              );
              if (user) {
                const userName = user.firstName + " " + user.lastName;
                return (
                  ticket.readableID.toLowerCase().includes(state.searchQuery) ||
                  ticket.subject.toLowerCase().includes(state.searchQuery) ||
                  ticket.description
                    .toLowerCase()
                    .includes(state.searchQuery) ||
                  userName.toLowerCase().includes(state.searchQuery)
                );
              } else {
                return (
                  ticket.readableID.toLowerCase().includes(state.searchQuery) ||
                  ticket.subject.toLowerCase().includes(state.searchQuery) ||
                  ticket.description.toLowerCase().includes(state.searchQuery)
                );
              }
            }
          }
        })
        .sort((a, b) => new Date(b.createdDate) - new Date(a.createdDate));
    },
    getClosedTickets(state) {
      return state.ticketList
        .filter((ticket) => {
          if (ticket.status == 4) {
            const user = state.userList.find(
              (user) => Number(user.userIdentifier) == ticket.userId
            );
            if (user) {
              const userName = user.firstName + " " + user.lastName;
              return (
                ticket.readableID.toLowerCase().includes(state.searchQuery) ||
                ticket.subject.toLowerCase().includes(state.searchQuery) ||
                ticket.description.toLowerCase().includes(state.searchQuery) ||
                userName.toLowerCase().includes(state.searchQuery)
              );
            } else {
              return (
                ticket.readableID.toLowerCase().includes(state.searchQuery) ||
                ticket.subject.toLowerCase().includes(state.searchQuery) ||
                ticket.description.toLowerCase().includes(state.searchQuery)
              );
            }
          }
        })
        .sort((a, b) => new Date(b.createdDate) - new Date(a.createdDate));
    },
    getMyTicket(state) {
      return state.ticketList
        .filter((ticket) => {
          if (ticket.status !== 4) {
            if (
              ticket.responderIDs.find(
                (id) => Number(id) == Number(state.myUser.id)
              )
            ) {
              const user = state.userList.find(
                (user) => Number(user.userIdentifier) == ticket.userId
              );
              if (user) {
                const userName = user.firstName + " " + user.lastName;
                return (
                  ticket.readableID.toLowerCase().includes(state.searchQuery) ||
                  ticket.subject.toLowerCase().includes(state.searchQuery) ||
                  ticket.description
                    .toLowerCase()
                    .includes(state.searchQuery) ||
                  userName.toLowerCase().includes(state.searchQuery)
                );
              } else {
                return (
                  ticket.readableID.toLowerCase().includes(state.searchQuery) ||
                  ticket.subject.toLowerCase().includes(state.searchQuery) ||
                  ticket.description.toLowerCase().includes(state.searchQuery)
                );
              }
            }
          }
        })
        .sort((a, b) => new Date(b.createdDate) - new Date(a.createdDate));
    },
    getResponderTicket(state) {
      return state.ticketList
        .filter((ticket) => {
          if (ticket.status !== 4) {
            if (
              !ticket.responderIDs.find(
                (id) => Number(id) == Number(state.myUser.id)
              ) &&
              ticket.handlerIds.find(
                (id) => Number(id) == Number(state.myUser.id)
              )
            ) {
              const user = state.userList.find(
                (user) => Number(user.userIdentifier) == ticket.userId
              );
              if (user) {
                const userName = user.firstName + " " + user.lastName;
                return (
                  ticket.readableID.toLowerCase().includes(state.searchQuery) ||
                  ticket.subject.toLowerCase().includes(state.searchQuery) ||
                  ticket.description
                    .toLowerCase()
                    .includes(state.searchQuery) ||
                  userName.toLowerCase().includes(state.searchQuery)
                );
              } else {
                return (
                  ticket.readableID.toLowerCase().includes(state.searchQuery) ||
                  ticket.subject.toLowerCase().includes(state.searchQuery) ||
                  ticket.description.toLowerCase().includes(state.searchQuery)
                );
              }
            }
          }
        })
        .sort((a, b) => new Date(b.createdDate) - new Date(a.createdDate));
    },
    getUserList: (state) => state.userList,
    getMessageList: (state) => state.messageList,
    getIsTyping: (state) => state.isTyping,
    getCompanyAgents: (state) => state.companyAgents,
    getNewTicket: (state) => state.newTicket,
    getSearchQuery: (state) => state.searchQuery,
    getActiveTicket: (state) => state.activeTicket,
    getHandlerIds(state) {
      if (state.activeTicket !== null) {
        const findTicket = state.ticketList.find(
          (ticket) => ticket.id == state.activeTicket
        );
        return findTicket.handlerIds;
      } else {
        return [];
      }
    },
    getResponderIDs(state) {
      if (state.activeTicket !== null) {
        const findTicket = state.ticketList.find(
          (ticket) => ticket.id == state.activeTicket
        );
        return findTicket.responderIDs;
      } else {
        return [];
      }
    },
    getSelectedTicket(state) {
      return state.ticketList.find((ticket) => ticket.id == state.activeTicket);
    },
    getIsAgent: (state) => state.isAgent,
    getUserIdList: (state) => state.userIdList,
  },
  actions: {
    async listenAllStand({ commit }) {
      plc.on("PLC_STATU", (message) => {
        commit("scadaBildirimStore/setAllStandStats", message, { root: true });
      });
    },
    async addObserverAndAgent({ commit, state, dispatch }, payload) {
      const { ticketId, selectedAgent, observerList } = payload;
      const findTicket = state.ticketList.find(
        (ticket) => ticket.id == ticketId
      );
      let responderIDs = "";
      if (Array.isArray(selectedAgent)) {
        responderIDs = selectedAgent;
      } else {
        responderIDs = [selectedAgent];
      }
      const handlerIds = observerList;
      const ticket = {
        ...findTicket,
        responderIDs: responderIDs,
        handlerIds: handlerIds,
      };
      customerSupport.invoke(state.key.UpdateTicket, ticket, findTicket);
    },
    async addUserToken({ commit, dispatch, state }, token) {
      commit("setUserToken", token);
      await comAxiosWithToken(state.userToken)
        .get("api/AccessTokens")
        .then((response) => {
          commit("setSignalRToken", response.data);
          localStorage.setItem("SignalRToken", response.data);
          dispatch("hubStarts");
        })
        .catch((error) => {});
    },
    async hubStarts({ commit, state, dispatch, rootState }) {
      await customerSupportHub(state.miniAuth);
      await userTrackerHub(state.miniAuth);
      await loggerHub(state.miniAuth);

      try {
        await startHub(userTracker);
        await startHub(customerSupport);
        await startHub(logger);

        if (
          rootState.checkPlatformStore.platformId == 9 ||
          state.myUser.b2BCariCode == null
        ) {
          dispatch("listenMessage");
          dispatch("listenCreatedTicket");
          dispatch("listenTicketUpdate");
          dispatch("joingLogViewer");
        } else {
          dispatch("b2bSignalRStore/listenMessage", null, { root: true });
          dispatch("b2bSignalRStore/listenTicket", null, { root: true });
        }
      } catch (error) {
        console.error(error);
        if (state.count <= 5) {
          setTimeout(async () => {
            await dispatch("addUserToken", localStorage.getItem("UserToken"));
          }, 5000);
        }
        commit("addCount");
      }
    },
    async getAllTickets({ commit, dispatch, state }) {
      await comAxiosWithToken(state.userToken)
        .get("api/Ticket")
        .then((response) => {
          commit("setTicketList", response.data);
        })
        .catch((error) => {});
      await commit("setUserIdList");
      await dispatch("getUserDatas");
    },
    async getUserDatas({ commit, state }) {
      if (state.userIdList.length > 0) {
        comAxiosWithToken()
          .post(`/api/UserData`, state.userIdList)
          .then((response) => {
            commit("setUserList", response.data);
          })
          .catch((error) => {});
      }
    },
    async addUser({ commit }, user) {
      commit("setMyUser", user);
    },
    async getMessageList({ commit }, ticketId) {
      comAxiosWithToken()
        .get(`/api/Messages/${ticketId}`)
        .then((response) => {
          commit("setMessageList", { id: ticketId, messages: response.data });
        })
        .catch((error) => {});
    },
    async listenMessage({ commit, state }) {
      customerSupport.on(state.key.NewMessage, (data) => {
        commit("addMessage", data);
      });
    },
    async joinGroup({ commit, state, dispatch }) {
      const ticketChat = "TicketChat_" + state.activeTicket;
      await customerSupport.invoke(state.key.joinGroup, ticketChat);
      await dispatch("listenTyping");
    },
    async addActiveTicket({ commit }, ticket) {
      commit("setActiveTicket", ticket);
    },
    async sendMessage({ commit, state }, messageValue) {
      const message = {
        Id: messageValue.id,
        ChatId: state.activeTicket,
        Message: messageValue.messageText,
        SenderId: state.myUser.id,
      };

      customerSupport
        .invoke(state.key.SendMessage, message)
        .then((data) => {})
        .catch((err) => {});
    },
    async resetState({ commit }) {
      commit("resetAll");
    },
    async listenCreatedTicket({ commit, state, dispatch }) {
      customerSupport.on(state.key.TicketCreated, async (data) => {
        commit("addTicket", data);
        commit("setUserIdList");
        await dispatch("getUserDatas");
        if (state.currentRoute !== "/customer_support") {
          commit("setNewTicket");
        }
      });
    },
    async sendTyping({ state }, payload) {
      customerSupport.invoke(
        state.key.SendTypingNotification,
        payload,
        payload.ChatId
      );
    },
    async listenTyping({ state, commit }) {
      customerSupport.on(state.key.Typing, (data) => {
        if (data.userId !== state.myUser.id) {
          commit("setIsTyping", data.isTyping);
        }
      });
    },
    async getAllAgents({ state, commit }) {
      await comAxiosWithToken(state.userToken)
        .get("api/Agent/getagents")
        .then((response) => {
          commit("setCompanyAgents", response.data);
          commit("setIsAgent", response.data);
        })
        .catch((error) => {
          commit("setIsAgent", false);
        });
    },
    async updateCurrentLocation({ commit }, route) {
      const { event, path } = route;
      commit("updateRoute", route);
      const move = {
        TraceId: localStorage.getItem("traceID"),
        PageName: path,
        Event: event,
      };

      if (logger && logger.state === "Connected") {
        logger.invoke("LogMovement", move, "Web").then((response) => {});
      }
    },
    async resetNewTicket({ commit }) {
      commit("resetNewTicket");
    },
    async closeTicket({ state, commit }, id) {
      const findTicket = state.ticketList.find((ticket) => ticket.id == id);
      const ticket = { ...findTicket, status: 4 };
      commit("setCloseTicket", id);
      customerSupport.invoke(state.key.UpdateTicket, ticket, findTicket);
    },
    async listenTicketUpdate({ state, commit, dispatch }) {
      customerSupport.on(state.key.TicketUpdated, async (data) => {
        commit("setUpdateTicket", data);
        await commit("setUserIdList");
        await dispatch("getUserDatas");
        if (
          data.handlerIds.find((id) => id == Number(state.myUser.id)) ||
          data.responderIDs.find((id) => id == Number(state.myUser.id))
        ) {
          if (state.currentRoute !== "/customer_support") {
            commit("setNewTicket");
          }
        }
      });
    },
    async addUserId({ state, commit, dispatch }, payload) {
      commit("addOneUserId", payload);
      dispatch("getUserDatas");
    },
    async getTraceId({}) {
      await logger.invoke("CrateTrace", "Web").then((response) => {
        localStorage.setItem("traceID", response);
      });
    },
    // async fetchPlcToken({ commit, dispatch }, payload) {
    //   await fetchAx
    //     .post("v1/Account/MiniAuth", payload)
    //     .then((response) => {
    //       commit("setMiniAuth", response.data.data.jwToken);
    //       localStorage.setItem("miniAuth", response.data.data.jwToken);
    //     })
    //     .catch((error) => {
    //       console.error("Error fetching data:", error);
    //     });
    // },
    async startPlcHub({ state, dispatch }) {
      if (!plc) {
        await plcHub(state.miniAuth);
        await startHub(plc);
        await dispatch("listenPlc");
        await dispatch("listenAllStand");
      }
    },
    async fetchPlcData({ state, commit }) {
      plc
        .invoke("ConnectedUsers")
        .then((connectedUsers) => {
          commit("scadaBildirimStore/setSectionConnectStatus", connectedUsers, {
            root: true,
          });
        })
        .catch((err) => {
          console.error("Error fetching connected users:", err);
        });
    },
    async listenPlc({ commit }) {
      plc.on("CONNECTION_CHANGED", (data) => {
        commit("scadaBildirimStore/setSectionConnectStatus", data, {
          root: true,
        });
      });
    },
    async joingLogViewer({ state, dispatch }) {
      await logger
        .invoke(state.key.joinGroup, "LogViewers")
        .then()
        .catch((err) => {});
    },
    async listenLog({ commit }) {
      logger.on("Logged", (data) => {
        const payload = {
          date: data.log.createdAt,
          event: data.log.event,
          message: null,
          pageName: data.log.pageName,
          platform: data.platform,
          traceId: data.traceId,
          user: data.user,
        };
        // commit("kullaniciTakipStore/addLogs", payload, { root: true });
      });
    },
    async sendCycleTime({ rootState }, payload) {
      const { plcCode, cycleTime } = payload;
      const sectionCode = rootState.scadaBildirimStore.selectedSection.PLC_KOD;

      await plc
        .invoke("UpdateCevrimSuresi", Number(cycleTime), plcCode, sectionCode)
        .then()
        .catch();
    },
    async listenPlcOrder({ rootState, commit, dispatch }, payload) {
      plc.on(
        `${rootState.scadaBildirimStore.selectedSection.PLC_KOD}_${payload}_PLC_DATA`,
        (data) => {
          const veri = {
            VARDIYA_ADET: data.vardiyA_ADET,
            VARDIYA_DUR_ZAMAN: data.vardiyA_DUR_ZAMAN,
            VARDIYA_URT_ZAMAN: data.vardiyA_URT_ZAMAN,
            VARDIYA_ZAMAN: data.vardiyA_ZAMAN,
            VARDIYA: data.vardiya,
            IS_EMRI: data.iS_EMRI_NO,
            CEVRIM_SURESI: data.cevriM_SUREI,
            IS_EMRI_MIKTAR: data.iS_EMRI_MIKTAR,
            ADET: data.adet,
            DINAMIK_CEVRIM_SURESI: data.dinamiK_CEVRIM_SUREI,
            ANLIK_DURUS: data.anliK_DURUS,
            DUR_ZAMAN: data.duR_ZAMAN,
            STATU: data.statu,
            URETIM_ZAMAN: data.urT_ZAMAN,
            ZAMAN: data.zaman,
            OPERATOR_NUMBER: data.operatoR_NUMBER,
            VARDIYA_TOTAL_ADET: data.vardiyA_TOTAL_ADET,
            SON_OKUTMA_ZAMANI: data.soN_OKUTMA_ZAMANI,
          };
          if (
            rootState.scadaBildirimStore.lastReadTime !== veri.SON_OKUTMA_ZAMANI
          ) {
            commit(
              "scadaBildirimStore/setLastReadTime",
              veri.SON_OKUTMA_ZAMANI,
              {
                root: true,
              }
            );
          }
          if (
            rootState.scadaBildirimStore.shiftTotalUnit !==
            veri.VARDIYA_TOTAL_ADET
          ) {
            commit(
              "scadaBildirimStore/setShiftTotalUnit",
              veri.VARDIYA_TOTAL_ADET,
              {
                root: true,
              }
            );
          }
          if (
            rootState.scadaBildirimStore.shiftUnitsProduced !==
            veri.VARDIYA_ADET
          ) {
            commit(
              "scadaBildirimStore/setShiftUnitsProduced",
              veri.VARDIYA_ADET,
              {
                root: true,
              }
            );
          }
          if (
            rootState.scadaBildirimStore.shiftStopTime !==
            veri.VARDIYA_DUR_ZAMAN
          ) {
            commit(
              "scadaBildirimStore/setShiftStopTime",
              veri.VARDIYA_DUR_ZAMAN,
              {
                root: true,
              }
            );
          }
          if (
            rootState.scadaBildirimStore.shiftTotalCycleTime !==
            veri.VARDIYA_URT_ZAMAN
          ) {
            commit(
              "scadaBildirimStore/setShiftTotalCycleTime",
              veri.VARDIYA_URT_ZAMAN,
              {
                root: true,
              }
            );
          }
          if (rootState.scadaBildirimStore.shiftTime !== veri.VARDIYA_ZAMAN) {
            commit("scadaBildirimStore/setShiftTime", veri.VARDIYA_ZAMAN, {
              root: true,
            });
          }
          if (rootState.scadaBildirimStore.shiftName !== veri.VARDIYA) {
            commit("scadaBildirimStore/setShiftName", veri.VARDIYA, {
              root: true,
            });
          }
          if (rootState.scadaBildirimStore.lastTime !== veri.ZAMAN) {
            commit("scadaBildirimStore/setLastTime", veri.ZAMAN, {
              root: true,
            });
          }
          if (
            rootState.scadaBildirimStore.totalCycleTime !== veri.URETIM_ZAMAN
          ) {
            commit("scadaBildirimStore/setTotalCycleTime", veri.URETIM_ZAMAN, {
              root: true,
            });
          }
          if (rootState.scadaBildirimStore.plcStatus !== veri.STATU) {
            commit("scadaBildirimStore/setPlcStatus", veri.STATU, {
              root: true,
            });
          }
          if (rootState.scadaBildirimStore.stopTime !== veri.DUR_ZAMAN) {
            commit("scadaBildirimStore/setStopTime", veri.DUR_ZAMAN, {
              root: true,
            });
          }
          if (
            rootState.scadaBildirimStore.momentaryStopTime !== veri.ANLIK_DURUS
          ) {
            commit(
              "scadaBildirimStore/setMomentaryStopTime",
              veri.ANLIK_DURUS,
              {
                root: true,
              }
            );
          }
          if (
            rootState.scadaBildirimStore.dynamicCycleTime !==
            veri.DINAMIK_CEVRIM_SURESI
          ) {
            commit(
              "scadaBildirimStore/setDynamicCycleTime",
              veri.DINAMIK_CEVRIM_SURESI,
              {
                root: true,
              }
            );
          }
          if (rootState.scadaBildirimStore.unitsProduced !== veri.ADET) {
            commit("scadaBildirimStore/setUnitsProduced", veri.ADET, {
              root: true,
            });
          }
          if (rootState.scadaBildirimStore.selectedBarcode !== veri.IS_EMRI) {
            commit("scadaBildirimStore/setSelectedBarcode", veri.IS_EMRI, {
              root: true,
            });
          }
          if (rootState.scadaBildirimStore.cycleTime !== veri.CEVRIM_SURESI) {
            commit("scadaBildirimStore/setCycleTime", veri.CEVRIM_SURESI, {
              root: true,
            });
          }
          if (
            rootState.scadaBildirimStore.productionQuantity !==
            veri.IS_EMRI_MIKTAR
          ) {
            commit(
              "scadaBildirimStore/setProductionQuantity",
              veri.IS_EMRI_MIKTAR,
              { root: true }
            );
          }
          if (
            rootState.scadaBildirimStore.operatorNumber !== veri.OPERATOR_NUMBER
          ) {
            commit(
              "scadaBildirimStore/setOperatorNumber",
              veri.OPERATOR_NUMBER,
              { root: true }
            );
          }
        }
      );
    },
    async stopListeningPlc({ rootState }) {
      if (rootState.scadaBildirimStore.selectedSection.PLC_KOD) {
        plc.off(
          `${rootState.scadaBildirimStore.selectedSection.PLC_KOD}_${rootState.scadaBildirimStore.selectedStand}_PLC_DATA`
        );
      }
    },
    async sendProductionQuantity({ rootState }, payload) {
      const { barcode, productionQuantity, plcCode, OPERATOR_NUMBER } = payload;
      const jobOrder = {
        ID: barcode,
        MIKTAR: Number(productionQuantity),
        OPERATOR_NUMBER: Number(OPERATOR_NUMBER),
      };
      const sectionCode = rootState.scadaBildirimStore.selectedSection.PLC_KOD;
      await plc
        .invoke("UpdateJob", jobOrder, plcCode, sectionCode)
        .then((response) => {})
        .catch((err) => {
          console.error("Error fetching connected users:", err);
        });
    },
    async resetJob({}, payload) {
      const { plcKod, tezgahKod } = payload;

      await plc.invoke("ResetSystem", plcKod, tezgahKod);
    },
    async plcBuzzerTest({ rootState }, payload) {
      let json = {
        Target: payload.buzzer.ADRES,
        Value: payload.checked,
      };
      await plc
        .invoke(
          "UpdateSpot",
          json,
          rootState.scadaBildirimStore.selectedStand,
          rootState.scadaBildirimStore.selectedSection.PLC_KOD
        )
        .then((response) => {})
        .catch((err) => {
          console.error("Error fetching connected users:", err);
        });
    },
    async startUploadHub({ state, commit }) {
      if (!upload) {
        await uploadHub(state.miniAuth);
        await startHub(upload).then((res) => {
          commit("fileUploadStore/setFileUploadConnId", res.connectionId, {
            root: true,
          });
        });
      }
    },
    async listenUpload({ state, commit }) {
      await upload.on("UploadProgress", (percentage, fileName, path) => {
        commit("fileUploadStore/setPercentage", percentage, { root: true });
      });
    },
    async addOperator({ rootState }, payload) {
      const { OPERATOR_NUMBER, plcCode } = payload;
      const sectionCode = rootState.scadaBildirimStore.selectedSection.PLC_KOD;
      await plc
        .invoke(
          "UpdateOperatorsNumber",
          Number(OPERATOR_NUMBER),
          plcCode,
          sectionCode
        )
        .then((response) => {})
        .catch((err) => {
          console.error("Error fetching connected users:", err);
        });
    },
  },
};
